import type {ReactElement} from 'react';
import React from 'react';
import type {RGBA} from '@Utils/color.util';
import {PosterEditingBaseDropdownOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-dropdown-option';
import {BaseGlowColorOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-glow-color-option';
import {GlowType} from '@PosterWhiteboard/poster/poster-backend.types';

interface BaseGlowOptionProps {
  glowColor: RGBA;
  glowType: GlowType;

  onApplyGlow(type: GlowType): void;

  onClickColorFill(): void;
}

export function BaseGlowOption({...props}: BaseGlowOptionProps): ReactElement {
  const getSubOption = (): ReactElement | null => {
    if (props.glowType === GlowType.LIGHT || props.glowType === GlowType.STRONG) {
      return (
        <BaseGlowColorOption
          glowType={props.glowType}
          glowColor={props.glowColor}
          onClickColorFill={(): void => {
            props.onClickColorFill();
          }}
        />
      );
    }

    return null;
  };

  const onClickHandler = (clickedId: GlowType): void => {
    if (Number(clickedId) === Number(props.glowType)) {
      return;
    }
    props.onApplyGlow(Number(clickedId));
  };

  return (
    <PosterEditingBaseDropdownOption
      id="item-glow-contextual-option"
      label={window.i18next.t('pmwjs_glow')}
      onClick={onClickHandler}
      dropdownItems={[
        {id: GlowType.NONE, text: window.i18next.t('pmwjs_none')},
        {id: GlowType.LIGHT, text: window.i18next.t('pmwjs_light_glow')},
        {id: GlowType.STRONG, text: window.i18next.t('pmwjs_strong_glow')},
      ]}
      selectedItemId={props.glowType}
    >
      {getSubOption()}
    </PosterEditingBaseDropdownOption>
  );
}
